import ATMLoadProfileAllComponent from './atm_load_profile.all.component';

let ATMLoadProfileAllModule = angular.module('atmLoadProfileAll', [
])

    .component('atmLoadProfileAll', ATMLoadProfileAllComponent)

    .name;

export default ATMLoadProfileAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/all/index.js